import { render, staticRenderFns } from "./RoomEditModal.vue?vue&type=template&id=40baad24&scoped=true&"
import script from "./RoomEditModal.vue?vue&type=script&lang=ts&"
export * from "./RoomEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40baad24",
  null
  
)

export default component.exports